import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import { useNewsletterForm } from '../../hooks/useNewsletterForm';

export default function Newsletter() {
  const { isSubmitting, error, success, handleSubmit } = useNewsletterForm();
  const [email, setEmail] = useState('');

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await handleSubmit(email);
    if (!error) {
      setEmail('');
    }
  };

  return (
    <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-8">
      <h3 className="text-2xl font-bold text-white mb-4">Stay Updated</h3>
      <p className="text-gray-300 mb-6">
        Get the latest Bitcoin news and BTM location updates.
      </p>
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="flex space-x-2">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            className="flex-1 px-4 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white focus:border-purple-500 focus:ring-1 focus:ring-purple-500"
            required
            disabled={isSubmitting}
          />
          <button
            type="submit"
            disabled={isSubmitting}
            className="bg-purple-600 hover:bg-purple-700 disabled:bg-purple-800 disabled:cursor-not-allowed text-white px-6 py-2 rounded-lg flex items-center space-x-2 transition-colors"
          >
            <Mail className="w-4 h-4" />
            <span>{isSubmitting ? 'Subscribing...' : 'Subscribe'}</span>
          </button>
        </div>
        {error && (
          <p className="text-red-400 text-center">{error}</p>
        )}
        {success && (
          <p className="text-green-400 text-center">Thanks for subscribing!</p>
        )}
      </form>
    </div>
  );
}